/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

/**
 * @param {boolean} targetingEnabled - enable or disable targeting in query
 */
const findCollectionsBySearchTerm = (targetingEnabled) => (
    // very important for serializing. add space between bracket and query name + add typenames to query
    gql`
    query SearchCollectionsQuery($brand: String!, $collectionOptions: CollectionOptions, $environment: String!, $term: String!${targetingEnabled ? ', $targeting: [Targeting]' : ''}) {
        findCollectionsBySearchTerm(brand: $brand, environment: $environment, term: $term, collectionOptions: $collectionOptions${targetingEnabled ? ', targeting: $targeting' : ''}) {
            collections {
                brand
                name
                description
                redirectUrl
                image
                seo {
                    canonicalUrl
                    metaDescription
                }
            }
            total
            pages
        }
    }
`
);

export default findCollectionsBySearchTerm;
